import { State } from '../reducers/types'

export const getShowAllFields = (state: State): boolean => state.adminQueryFlags.showAllFields
